module.exports = __webpack_public_path__ + "static/Ettlinger_Ziele-2fc27aee0b39275e19e281a45091de0e.pdf";